// extracted by mini-css-extract-plugin
module.exports = {"form-input":"update-password_form-input__2p_f_","hint":"update-password_hint__31sUu"};